// src/components/Footer.jsx
import React from "react";
import "./Footer.css";

// adjust filenames to match your SVGs
import { ReactComponent as LinkedInIcon } from "./SVGs/LinkedIn.svg";
import { ReactComponent as YouTubeIcon } from "./SVGs/YouTube.svg";
import { ReactComponent as InstagramIcon } from "./SVGs/Instagram.svg";
import { ReactComponent as XIcon } from "./SVGs/X.svg";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-container">
        <nav className="footer-navigation">
          <a href="/contact">Contact me</a>
          <a href="/privacy">Privacy Notice</a>
          <a href="/terms">Terms of Use</a>
          <div className="footer-social">
            <a
              href="https://www.linkedin.com/in/george-sotirov/"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon className="footer-icon" />
            </a>
            <a
              href="https://www.youtube.com/@george-sotirov"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon className="footer-icon" />
            </a>
            <a
              href="https://www.instagram.com/georgesotirov/"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon className="footer-icon" />
            </a>
            {/*
  <a
    href="https://twitter.com/yourprofile"
    aria-label="X"
    target="_blank"
    rel="noopener noreferrer"
  >
    <XIcon className="footer-icon" />
  </a>
  */}
          </div>
        </nav>
        <div className="footer-legal">
          <p>© {new Date().getFullYear()} George Sotirov.</p>
          <p>
            All rights reserved. Website created by George Sotirov and design
            inspired by{" "}
            <a
              href="https://www.riotgames.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-legal-link"
            >
              Riot Games
            </a>
            .
          </p>
        </div>
        <div className="footer-legal-warning">
          <p>
            {" "}
            All materials, including but not limited to video content, graphics,
            and designs, are protected under applicable copyright laws.
            Unauthorized use is strictly prohibited.{" "}
          </p>
        </div>
      </div>
    </footer>
  );
}
